import { useEffect, useState } from 'react'
import { AnimatePresence } from '@cnd/elements'

const LazyAnimatePresence = ({ children, ...rest }) => {
  const [onClient, setOnClient] = useState(false)

  useEffect(() => {
    setOnClient(true)
  }, [])

  if (onClient) return <AnimatePresence {...rest}>{children}</AnimatePresence>

  return children
}

export default LazyAnimatePresence
